import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-campaigns',
  templateUrl: './campaigns.component.html',
  styleUrls: ['./campaigns.component.css', '../../../assets/website/assets/css/bootstrap.min.css']
})
export class CampaignsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
